<template>
    <md-dialog class="create-circle-dialog" :md-active.sync="visible">
        <md-dialog-title>Create New Circle</md-dialog-title>
        <md-dialog-content>
            <md-field>
                <label>Circle Name</label>
                <md-input v-model="circle.name" required />
            </md-field>

            <md-field>
                <label>Circle Code(lowercase, no spaces)</label>
                <md-input v-model="circle.short" :rules="codeRules" required />
            </md-field>
            <md-field>
                <label>Circle Page URL</label>
                <md-input
                    v-model="circle.circlePageUrl"
                    placeholder="https://xxx.protopia.co"
                    required
                    @input="circle.circlePageUrl = ensureHttpsScheme(sanitizeUrl($event))"
                />
            </md-field>
            <md-field>
                <label>Action Page</label>
                <md-select v-model="circle.actionPage">
                    <md-option value="null" disabled>Select an option</md-option>
                    <md-option
                        v-for="(page, index) in actionPageOptions"
                        :key="page.code"
                        :value="page.code"
                    >
                        {{ page.name }}
                    </md-option>
                </md-select>
            </md-field>

            <md-field>
                <label>Administrators (comma-separated)</label>
                <md-input v-model="circle.administrators" />
            </md-field>
        </md-dialog-content>

        <md-dialog-actions>
            <md-button @click="$emit('cancel')">Cancel</md-button>
            <md-button class="md-primary" :disabled="!isValid" @click="save">Save</md-button>
        </md-dialog-actions>
    </md-dialog>
</template>

<script>
import API from '../services/API';
import { sanitizeUrl, ensureHttpsScheme } from '../utils/sanitizer';
export default {
    name: 'CreateCircle',
    props: {
        visible: Boolean,
        communityId: {type: String, required: true}
    },
    data() {
        return {
            circle: {name: '', short: '', circlePageUrl: '', actionPage: null, administrators: ''},
            actionPageOptions: []
        };
    },
    watch: {
        visible(val) {
            if (val) this.fetchActionPages();
        }
    },
    computed: {
        codeRules() {
            return [
                v => /^[a-z0-9_]+$/.test(v) || 'Must be lowercase letters, numbers or underscore'
            ];
        },
        urlPattern() {
            return /^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&%\$#_]*)?$/;
        },
        isValid() {
            return (
                this.circle.name &&
                this.codeRules.every(r => r(this.circle.short) === true) &&
                this.urlPattern.test(this.circle.circlePageUrl)
            );
        }
    },
    methods: {
        sanitizeUrl,
        ensureHttpsScheme,
        async fetchActionPages() {
            const api = new API();
            try {
                const res = await api.get('action/get-action-pages');
                this.actionPageOptions = res.data;
            } catch (e) {
                console.error('Failed to load action pages:', e);
            }
        },
        save() {
            this.$emit('save', { ...this.circle });
            // clear form
            this.circle = { name: '', short: '', circlePageUrl: '', actionPage: null, administrators: '' };
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/CreateCircle.vue